import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import DefaultCard from '../../../../../../components/default/DefaultCard';
import DefaultToolBar from '../../../../../../components/default/DefaultToolBar';
import ButtonCreate from '../../../../../../components/buttons/ButtonCreate';
import DefaultModal from '../../../../../../components/default/DefaultModal';
import { ServiceResponse } from '../../../../../../app/services/shared/interfaces';
import useSweetAlert from '../../../../../../hooks/useSweetAlert';
import WarehouseQuoteRateCreate from '../WarehouseRateCreate';
import WarehouseQuoteRateEdit from '../WarehouseRateEdit';
import WarehouseRatesDataTable from '../tables/WarehouseQuoteRateDataTable';
import { WarehouseQuoteRate, WarehouseQuoteRateDataForm, WarehouseQuoteRateFilters, WarehouseQuoteShowRateDataForm } from '../../../../../../app/models/WareHouseQuoteRates';
import useWarehouseQuoteRateService from '../../../../../../app/services/hooks/useWareHouseQuoteRateService';
import WarehouseRatesShowForm from '../forms/WareHouseRatesForms/WareHouseRatesShowForm';
import useReactConfirmAlert from '../../../../../../hooks/useReactConfirmAlert';
import { Currency } from '../../../../../../app/models/Currency';
import { Depot } from '../../../../../../app/models/Depot';
import { Product } from '../../../../../../app/models/Product';
import { Unit } from '../../../../../../app/models/Unit';
import { AppContext } from '../../../../../../contexts/AppContext';
import WarehouseQuoteRateShow from '../WarehouseRateShow';

interface Props {
    quoteId: number;
    disableUpdate?: boolean;
    isFormShow?: boolean;
    refresh?: number;
    rates?: WarehouseQuoteRateDataForm;
}

const WarehouseQuoteRatesContainer = ({ 
    quoteId,
    disableUpdate = false,
    isFormShow = false,
    refresh,
    rates
}: Props) => {
    const {
        getAllWarehouseQuoteRatesByQuote,
        deleteWarehouseQuoteRate,
        editWarehouseQuoteRate,
        showWarehouseQuoteRate,
        fetchingGetWarehouseQuoteRates
    } = useWarehouseQuoteRateService();

    const [warehouseQuoteRates, setWarehouseQuoteRates] = useState<WarehouseQuoteRate[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [filter, setFilter] = useState<WarehouseQuoteRateFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });

    const [showingCreate, setShowingCreate] = useState(false);
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingShow, setShowingShow] = useState(false);

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [warehouseRateIdEdit, setWarehouseRateIdEdit] = useState<number>(-1);
    const [rateIdEdit, setRateIdEdit] = useState<number>(-1);
    const [rateIdShow, setRateIdShow] = useState<number>(-1);

    useEffect(() => {
        if (quoteId) reloadTable();
    }, [quoteId, filter, refresh]);

    const reloadTable = () => {
        getAllWarehouseQuoteRatesByQuote(quoteId,filter, {
            onSuccess: (response: ServiceResponse) => {
                setWarehouseQuoteRates(response.data.warehouse_quote_rates);
                setTotalRows(response.data.total_rows);
            }
        });
    };

    const showEdit = (id: number) => {
        setShowingEdit(true);
        setWarehouseRateIdEdit(id);
    };
    const showShow = (id: number) => {
        setShowingShow(true);
        setRateIdShow(id);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setWarehouseRateIdEdit(-1);
    };

    const hideShow = () => {
        setShowingShow(false);
        setRateIdShow(-1);
    };

    const destroy = (id: number) => {
        const message = `Está a punto de eliminar la tarifa #${id}`;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: message,
            buttons: {
                confirmButton: {
                    label: 'Sí, eliminar',
                    onClick: () => {
                        if (showLoading)
                            showLoading('loading', 'Eliminando tarifa...');

                        deleteWarehouseQuoteRate(id, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'Cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'La tarifa no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };

    return (
        <>

            <DefaultCard>
                <div className="h3 mt-0 mb-4 card-title">Tarifas</div> 
                <div className="row">
                    <div className="col-12">
                        {!disableUpdate && (
                            <DefaultToolBar left={<ButtonCreate callbackCreate={() => setShowingCreate(true)} />} />
                        )}
                    </div>
                    <div className="col-12">
                        <WarehouseRatesDataTable
                            warehouseQuoteRates={warehouseQuoteRates}
                            totalRows={totalRows}
                            loading={fetchingGetWarehouseQuoteRates}
                            show={showShow}
                            edit={showEdit}
                            destroy={destroy}
                            filter={filter}
                            setFilter={setFilter}
                            isShow={isFormShow}

                        />
                    </div>
                </div>
            </DefaultCard>
            {showingCreate ? (

            <DefaultModal
                show={showingCreate}
                handleClose={() => setShowingCreate(false)}
                title="Crear Tarifa"
                showFooter={false}
            >
                <WarehouseQuoteRateCreate
                    quoteId={quoteId}
                    onSaved={() => {
                        reloadTable();
                        setShowingCreate(false);
                    }}
                    onCancel={() => setShowingCreate(false)}
                />
            </DefaultModal>
            ) : null}

            {showingEdit ?(
            <DefaultModal
                show={showingEdit}
                handleClose={() => setShowingEdit(false)}
                title="Editar Tarifa"
                showFooter={false}
            >
                <WarehouseQuoteRateEdit

                    rateId={warehouseRateIdEdit}
                    onSaved={() => {
                        reloadTable();
                        setShowingEdit(false);
                    }}
                    onCancel={() => setShowingEdit(false)}
                />
            </DefaultModal>
            ) : null}
            {showingShow ?(
            <DefaultModal
                show={showingShow}
                handleClose={hideShow}
                title="Ver Tarifa"
                showFooter={false}
            >
                <WarehouseQuoteRateShow 
                rateId={rateIdShow}
                onCancel={hideShow}

                 />
            </DefaultModal>
                    ) : null}
        </>
    );
};

export default WarehouseQuoteRatesContainer;
